import { render, staticRenderFns } from "./registeReview.vue?vue&type=template&id=01609d60&scoped=true&"
import script from "./registeReview.vue?vue&type=script&lang=js&"
export * from "./registeReview.vue?vue&type=script&lang=js&"
import style0 from "./registeReview.vue?vue&type=style&index=0&id=01609d60&lang=scss&scoped=true&"
import style1 from "./registeReview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01609d60",
  null
  
)

export default component.exports